/**
 * Contact Service
 * To construct the template for Call Us page and Email Page
 * Left Side: Email/CallUs
 * Right Side: Find Quick Answers
 */

import React from 'react';
import PropTypes from 'prop-types';
import ErrorHandler from '../containers/ErrorHandler';
import AlertsContainer from '../containers/Alerts';
import ColumnLayout from './common/ColumnLayout';

import Page from '../../lib/page';
import ModalContainer from '../containers/ModalContainer';
import { isPrivacyWebFormEnabledInRC } from '../../lib/globalHelper';

// Constants
const { error: { contact } } = Page.getLocaleContent('Error');

/**
 * New layout for Privacy webform page
 * Can be used for any page with the same layout
 */
const getEmailFormLayoutStyle = (kanaCode) => {
  const isNewPrivacyPageEnabledInRC = (isPrivacyWebFormEnabledInRC(kanaCode)) || false;
  if (isNewPrivacyPageEnabledInRC) {
    return 'fourty-sixty-layout';
  }
  return '';
};

const ContactService = (props) => (
  <ErrorHandler contactError={contact}>
    <div className="page-main-container">
      <AlertsContainer />
      <ModalContainer />
      <ColumnLayout
        leftPanel={props.leftPanel}
        rightPanel={props.rightPanel}
        customizeStyle={getEmailFormLayoutStyle(props.kanaCode)}
      />
    </div>
  </ErrorHandler>
);

// Contact Service PropTypes
ContactService.propTypes = {
  leftPanel: PropTypes.element.isRequired,
  rightPanel: PropTypes.element.isRequired,
  kanaCode: PropTypes.string,
};

export default ContactService;
